import axios from "axios"
import { store } from "@/store/store"

export default class ApiService {
    baseHref: string

    constructor(baseHref: string) {
        this.baseHref = baseHref
    }

    get currentLanguage() {
        return store.getters.activeLang
    }

    // Generate errorstring from Error
    generateErrorMsg(e: any): string {
        let errormsg: string = ""
        // Virheilmoitus vue notificationiin.
        if (e.response.data !== null) {
            errormsg = e.response.data
            // TODO OKo: Notify
            /* store.dispatch("setLoading", false)*/
        }
        return errormsg
    }

    // api methods
    async getConfigValues(): Promise<any> {
        try {
            const response = await axios.get(this.baseHref + "api/Utils/GetConfigValues")
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getPageWhitelist(): Promise<any> {
        try {
            const response = await axios.get(this.baseHref + "api/Utils/GetPageWhitelist")
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getLegendLimits(): Promise<any> {
        try {
            const response = await axios.get(this.baseHref + "api/Utils/GetLegendLimits")
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async changeLanguage(langId: string): Promise<any> {
        try {
            const response = await axios.post(this.baseHref + "api/Utils/ChangeLanguage?langId=" + langId)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    // Osoitehaku
    async getGeocodingAddress(address: string, lang: string): Promise<any> {
        try {
            const res = await axios.get(store.getters.mapServicesUrl + "SearchMultipleSources?text=" + address + "&lang=" + lang + "&size=500")
            return res.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    // Hae paikannetun sijainnin arvioitu katuosoite (käänteinen geokoodaus)
    async getReverseGeocodingLocation(lat: number, lng: number, lang: string): Promise<any> {
        try {
            const res = await axios.get(store.getters.mapServicesUrl + "ReverseGeocoding?point.lat=" + lat + "&point.lon=" + lng + "&lang=" + lang + "&sources=interpolated-road-addresses&size=1")
            return res.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getLanguageTerms() {
        try {
            const response = await axios.get(this.baseHref + "api/Utils/GetLanguageTerms")
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async dynamicApiCall(url: string, parameters?: URLSearchParams) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + url, { params: parameters })
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getPopupDetailsPosti(markerId) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Viestinta/Posti/Postipalvelut/" + markerId)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getPopupDetailsPostiTyyppi(types: number[], ids: string[] | null) {
        try {
            const response = await axios.post(store.getters.dataPublishServicesUrl + "v1/Viestinta/Posti/Postipalvelut/tyypit", { tyyppi: types, ids })
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getLiikenteenTilastotKuntaData(type: string, kuntanumero: string) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/TieLiikenne/TieliikenteenTilastot/LiikenteenTilastotYksittainenKunta?type=" + type + "&kuntanumero=" + kuntanumero)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getLiikenteenTilastotMaakuntaData(type: string, maakuntanumero: string) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/TieLiikenne/TieliikenteenTilastot/LiikenteenTilastotYksittainenMaakunta?type=" + type + "&maakuntanumero=" + maakuntanumero)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getBittimittariVuorokausiKuntaData(kuntanumero: string) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Bittimittari/VuorokaudenAikaKlusteritYksittainenKunta?kuntanumero=" + kuntanumero)

            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getBittimittariVuorokausiMaakuntaData(maakuntanumero: string) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Bittimittari/VuorokaudenAikaKlusteritYksittainenMaakunta?maakuntanumero=" + maakuntanumero)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getBittimittariOperaattoriKuntaData(kuntanumero: string, operaattoriId: number) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Bittimittari/VerkkoOperaattoriKlusteritYksittainenKunta?kuntanumero=" + kuntanumero + "&operaattoriId=" + operaattoriId)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getBittimittariOperaattoriMaakuntaData(maakuntanumero: string, operaattoriId: number) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Bittimittari/VerkkoOperaattoriKlusteritYksittainenMaakunta?maakuntanumero=" + maakuntanumero + "&operaattoriId=" + operaattoriId)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getBittimittariOperators(): Promise<any> {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/Bittimittari/VerkkoOperaattorit")
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }

    async getMunicipalityByWGS84(lat: number, lng: number) {
        try {
            const response = await axios.get(store.getters.dataPublishServicesUrl + "v1/AreaInfoService/KuntaWGS84?lat=" + lat + "&lng=" + lng)
            return response.data
        }
        catch (err) {
            throw new Error(this.generateErrorMsg(err))
        }
    }
}
